import {Component, EventEmitter, Input, Output} from '@angular/core';

const LONG_LABEL_LIMIT: number = 5;

@Component({
  selector: 'result-bar',
  templateUrl: 'result-bar.html',
  styleUrls: ['result-bar.scss'],
})
export class ResultBarComponent {

    @Input()
    public title: string;

    @Input()
    public value: number = 0;

}
